import { StateCreator } from 'zustand';
import { StoreSlices } from '.';

export interface SlidePanelProps {
  productInfo: any;
  isOpen: boolean;
  finalFocusRef: any;
}

export interface SlidePanelSlice extends SlidePanelProps {
  openSlidePanel: () => void;
  closeSlidePanel: () => void;
  setProductInfo: (productInfo: any) => void;
}

export const createSlidePanelSlice =
  (
    initProps?: Partial<SlidePanelProps>,
  ): StateCreator<
    Partial<StoreSlices>,
    [['zustand/devtools', never], ['zustand/immer', never]],
    [],
    SlidePanelSlice
  > =>
  (set, get) => ({
    isOpen: initProps?.isOpen,
    finalFocusRef: initProps?.finalFocusRef,
    productInfo: initProps?.productInfo ?? {},
    openSlidePanel: () =>
      set(
        (state) => {
          state.slidePanel.isOpen = true;
        },
        undefined,
        'slidePanel/openSlidePanel',
      ),
    closeSlidePanel: () =>
      set(
        (state) => {
          // const finalFocusRef = get().slidePanel.finalFocusRef;
          // finalFocusRef?.current?.focus();
          state.slidePanel.isOpen = false;
        },
        undefined,
        'slidePanel/closeSlidePanel',
      ),
    setProductInfo: (productInfo: any) =>
      set(
        (state) => {
          const { finalFocusRef, ...rest } = productInfo;
          // TODO implement final focus ref in a different way because doing this will lag the app
          // state.slidePanel.finalFocusRef = finalFocusRef;
          state.slidePanel.productInfo = rest;
        },
        undefined,
        'slidePanel/setProductInfo',
      ),
  });
